<template src="./index.html"></template>
<script>
import { Dialog, Popup } from "vant";
import { mapState } from 'vuex';
import SelfTabbar from '@/components/SelfTabbar';
import MerchantsDay20210312 from '@/components/MerchantsDay20210312_APP';
import ManualHelp from '@/components/ManualHelp_APP';
import CouponsPopup from "@/components/CouponsPopup";
export default {
  name: "set",
  components: { Dialog, Popup, SelfTabbar, MerchantsDay20210312, ManualHelp, CouponsPopup },
  data() {
    return {
      TabbarActive: 3,
      dialogVisible: false,
      listdivShow: false,
      tanDivShow: false,
      marginLeft: "0",
      active: "active",
      itemIndex: 0,
      listDivShow: false,
      // 保存的用户信息
      user: "",
      // 店铺列表
      stroeList: [],
      stroeNum: 0,
      contentShow: false,
    };
  },
  computed: {
    ...mapState({
      getSappMenuInfo: (state) => {
        return state.Public.getSappMenuInfo;
      },
      UserInfo: (state) => {
        return state.Public.UserInfo;
      },
    }),
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch("set/GetSetData").then((res) => {
        this.contentShow = true
        this.user = res.data;
        if(this.$store.state.Public) {
          if(this.$store.state.Public.setData) {
            if(this.$store.state.Public.setData.stroeName) {
              this.user.visitor_nick = this.$store.state.Public.setData.stroeName
            }
          }
        }
      });
    },
    sendNews() {
      this.$store.dispatch('Public/inH5Record',{btn_name:'设置页群发消息'})

      Dialog.alert({
        title: "",
        message: "该功能正在开发中\n请耐心等待",
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: "关闭",
        width: "80vw",
      }).catch(() => {});
    },
    setChild() {
      this.$store.dispatch('Public/inH5Record',{btn_name:'设置子账号权限'})

      Dialog.alert({
        title: "",
        message: "该功能正在开发中\n请耐心等待",
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: "关闭",
        width: "80vw",
      }).catch(() => {});
    },
    zheShow() {
      this.dialogVisible = false;
      this.listDivShow = false;
      this.tanDivShow = false;
      this.marginLeft = "0";
    },
    listShow() {
      if(this.user.boss_num > 1) {
        this.listDivShow = true;
        this.marginLeft = "60vw";
        this.$store.dispatch("set/GetSetList").then((res) => {
          this.stroeList = res.data.list;
        });
      }else {
        if(this.user.boss_num == 1) {
          Dialog.alert({
            title: "",
            message: "您当前只有一个店铺",
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: "关闭",
            width: "80vw",
          }).catch(() => {});
        }
        if(this.user.boss_num == 0) {
          Dialog.alert({
            title: "",
            message: "您当前未绑定店铺",
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: "关闭",
            width: "80vw",
          }).catch(() => {});
        }
      }
    },
    cancelTan() {
      this.dialogVisible = false;
      this.tanDivShow = false;
    },
    stroeChange(index, _id, _name) {
      // this.contentShow = false
      let stroeObj = {oldStroe:{}, newStroe:{}}
      stroeObj.oldStroe.visitor_nick = this.user.visitor_nick
      stroeObj.oldStroe.visitor_id = this.user.visitor_id
      stroeObj.newStroe.visitor_nick = _name
      stroeObj.newStroe.visitor_id = _id
      
      this.UserInfo.visitor_id = _id
      this.$store.commit("Public/UserInfo",{data: this.UserInfo});

      this.$store.dispatch('Public/inH5Record',{btn_name:'设置切换店铺',page_param:stroeObj})
      this.$store
        .dispatch("set/ChangeStroe", { visitor_id: _id })
        .then((res) => {
          if (res.code == "1000") {
            let objData = {stroeName: _name, stroeId: _id, stroeIndex: index}
            this.$store.commit("Public/SET_DATA",{key:'setData', data: objData})
            // this.user.visitor_nick = _name;
            // this.user.visitor_id = _id;
            location.reload()
          }
        });
      this.itemIndex = index;
      this.dialogVisible = false;
      this.listDivShow = false;
      this.marginLeft = "0";

    },
    closeTan() {
      this.listDivShow = false;
      this.marginLeft = "0";
    },
  },
  beforeDestroy() {
    let objData = {stroeName: this.user.visitor_nick, stroeId: this.user.visitor_id, stroeIndex: this.itemIndex}
    this.$store.commit("Public/SET_DATA",{key:'setData', data: objData})
  }
};
</script>
<style lang="scss" src="./index.scss" scoped></style>
<style lang="less">
#setMain .van-tabbar {
  z-index: 20;
}
</style>